<template>
    <!-- PRODUCT-26110 Task 12b (INSTANCE_ATTRS_CLASS_STYLE): Vue 3 folds class/style
         into $attrs and stops auto-applying them to root when inheritAttrs is false;
         merge a caller's class/style (e.g. InterviewCard.vue's forwarded classes) in
         alongside this component's own hardcoded root class/style to keep the old
         Vue 2 fallthrough behavior. -->
    <div
        role="main"
        class="SingleCol"
        :class="[{ 'SingleCol--stretch': stretch, 'SingleCol--center': center }, $attrs.class]"
        :style="$attrs.style"
    >
        <div class="SingleCol__body">
            <slot />
        </div>
        <div class="SingleCol__footer" :class="{'SingleCol__footer--stretchX': footerStretchX}">
            <slot name="footer">
                <LogoFooter />
                <LanguagePicker v-if="localizationEnabled" />
            </slot>
        </div>
        <!-- The ido store is a flat Pinia store: askAgent sits at its root, and the
             chat state under `onlineChat`. There is no Vuex $store to look either up in. -->
        <OnlineChat
            v-if="shouldRenderChat"
            :custom-store="idoStore"
            custom-state-path="onlineChat"
            class="hidden md:block"
        />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from 'vue-property-decorator';

    import OnlineChat from '@evidentid/dashboard-commons/modules/online-chat/components/OnlineChat/OnlineChat.vue';

    import LanguagePicker from '@/components/common/LanguagePicker.vue';
    import LogoFooter from '@/components/common/LogoFooter.vue';
    import support from '@/config/support';
    import { useIdoStore } from '@/store/store';

    @Component({
        inheritAttrs: false,
        components: { LanguagePicker, LogoFooter, OnlineChat },
    })
    export default class SingleCol extends Vue {
        @Prop({ type: Boolean, default: false })
        private stretch!: boolean;

        @Prop({ type: Boolean, default: false })
        private footerStretchX!: boolean;

        @Prop({ type: Boolean, default: false })
        private center!: boolean;

        @Prop({ type: Boolean, default: false })
        private isChatAvailable!: boolean;

        private get shouldRenderChat(): boolean {
            return this.isChatAvailable && !this.isMobileBrowser();
        }

        private get idoStore(): ReturnType<typeof useIdoStore> {
            return useIdoStore();
        }

        private get localizationEnabled(): boolean {
            return Boolean(useIdoStore().issuer?.localizationEnabled);
        }

        // wrapper so that we can control this variable in unit test in order to test shouldRenderChat correctly
        private isMobileBrowser(): boolean {
            return support.isMobileBrowser;
        }
    }
</script>
